// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"1421":"929902e421153544cf29","8750":"de44a252e3f29342dcc5"}[chunkId] + ".css";
};